/**
 * 设备资产统计分析 — POST /api/produce/kanban/device-asset-statistics
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/device-asset-statistics'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchDeviceAssetStatistics(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
